import { FonteConsultaImoveis, TenantConfig } from './system.reducer';

export const DEFAULT_FONTE_CONSULTA_IMOVEIS: FonteConsultaImoveis =
  'portal_info_lote';

export function getFonteConsultaImoveis(
  tenantConfig?: TenantConfig | null
): FonteConsultaImoveis {
  const fonte = tenantConfig?.portalConfig?.fonteConsultaImoveis;

  switch (fonte) {
    case 'legado':
    case 'criciuma':
    case 'portal_info_lote':
      return fonte;
    default:
      return DEFAULT_FONTE_CONSULTA_IMOVEIS;
  }
}

export interface PortalDocumentosResolved {
  habilitar: boolean;
  publico: boolean;
}

/** Sem configuração o portal mantém o comportamento atual: tudo visível. */
export const DEFAULT_PORTAL_DOCUMENTOS: PortalDocumentosResolved = {
  habilitar: true,
  publico: true,
};

/**
 * Resolve a visibilidade dos documentos no portal para uma camada.
 * Prioridade campo a campo: entrada da camada > valor do tenant > padrão.
 * `undefined` cai para o próximo nível; `false` explícito prevalece.
 */
export function resolvePortalDocumentosConfig(
  tenantConfig: TenantConfig | string | null | undefined,
  layerId: number | string | null | undefined
): PortalDocumentosResolved {
  const config =
    tenantConfig && typeof tenantConfig === 'object' ? tenantConfig : null;
  const documentos = config?.portalConfig?.documentos;
  const entry =
    layerId !== null && layerId !== undefined
      ? documentos?.camadas?.[String(layerId)]
      : undefined;

  return {
    habilitar:
      entry?.habilitar ??
      documentos?.habilitar ??
      DEFAULT_PORTAL_DOCUMENTOS.habilitar,
    publico:
      entry?.publico ??
      documentos?.publico ??
      DEFAULT_PORTAL_DOCUMENTOS.publico,
  };
}

export function canShowPortalDocumentos(
  config: PortalDocumentosResolved,
  isLoggedIn: boolean
): boolean {
  return config.habilitar && (config.publico || isLoggedIn);
}

/**
 * Ajustes de estabilidade da avaliação valem só para Criciúma por enquanto (#4057);
 * os outros municípios mantêm o comportamento anterior até serem testados.
 */
export function isCriciumaTenant(
  tenantConfig: TenantConfig | string | null | undefined
): boolean {
  return (
    typeof tenantConfig === 'object' && tenantConfig?.cidade === 'criciuma'
  );
}
